module.exports = __webpack_public_path__ + "fonts/SuisseIntl-SemiBold.9932268.woff2";